<template>
    <div>
        
        <div class="table-main-actions-container">
            <div class="table-actions-container">
                <div class="row">
                    <div class="sorting-container col-4">
                        <el-button type="info" link @click="refreshOffers">
                            <font-awesome-icon icon="fa-solid fa-compass-drafting"/>
                            <span style="margin-left:5px;"> All Offers </span>
                        </el-button>
                    </div>
                    
                </div>
            </div>
        </div>

        <el-table :row-class-name="tableRowClassName" v-loading="isLoading" element-loading-text="Loading..." element-loading-background="rgba(255, 255, 255, 0.8)" :data="offers" style="width: 100%" :header-row-class-name="'table-header-style'" :header-cell-class-name="'table-header-cell-style'" :highlight-current-row="true" :cell-class-name="'custom-cell'">
            <el-table-column prop="id" label="ID" width="80" />
            <el-table-column label="Name">
                <template #default="scope">
                    {{ scope.row.name }}
                </template>
            </el-table-column>

            <el-table-column label="Image">
                <template #default="scope">
                    <el-image
                        style="width: 40px; height: 40px"
                        :src="'https://tapegypt.com/offers-photos/'+scope.row.photo_link"
                        :zoom-rate="1.2"
                        :max-scale="7"
                        :min-scale="0.2"
                        
                        :initial-index="4"
                        fit="cover"
                    />
                </template>
            </el-table-column>

            <el-table-column label="Actions" width="150" align="center">
                <template #default="scope">
                    <!-- <el-button size="small" @click="openEditForm(scope.row,scope.$index)" icon="Edit" circle v-if="!scope.row.is_edit_active"/> -->
                    <el-button
                        size="small"
                        type="danger"
                        icon="Delete"
                        circle
                        @click="deleteOffer(scope.row)"
                        v-if="!scope.row.is_edit_active"
                    />
                    <el-button type="success" :icon="Check" circle v-if="scope.row.is_edit_active" @click="EditProject(scope.$index)"/>
                    <el-button type="info" :icon="Close" circle @click="closeEdit(scope.$index)" v-if="scope.row.is_edit_active"/>
                </template>
            </el-table-column>
        </el-table>

        <!-- Add/Edit Drawer -->
        <!-- <el-drawer v-model="showDrawer" direction="rtl" size="40%">
            <template #header>
                <h4>{{ isEditing ? 'Edit Offer' : 'Add New Offer' }}</h4>
            </template>

            
        </el-drawer> -->

        <!-- <div class="pagination-container">
            <el-pagination
                :page-size="offers.per_page"
                :current-page="currentPage"
                :total="offers.total"
                layout="prev, pager, next"
                @current-change="handlePageChange"
            />
        </div> -->
    </div>
</template>

<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import { onMounted, ref , computed , reactive } from 'vue';
import { useStore } from 'vuex';


export default {
    name: 'Offers',
    setup(){
        const store = useStore();
        const currentPage = ref(1);
        const searchValue = ref('');
        const showDrawer = ref(false);
        const isEditing = ref(false);
        const form = ref({
            id: null,
            name: '',
            image: null
        });
        const Edited_model = ref({});

        // Getters
        const offers = ref([]);
        const isLoading = ref(false);

        // Actions
        const fetchOffers = async () => await store.dispatch('offers/fetchOffers');
        const addNewOffer = (offer) => store.dispatch('offers/addNewOffer', offer);
        const updateExistingOffer = (offer) => store.dispatch('offers/updateExistingOffer', offer);
        const deleteExistingOffer = (id) => store.dispatch('offers/deleteExistingOffer', id);

        onMounted(async () => {
            isLoading.value = true;
            await fetchOffers();
            offers.value = store.getters['offers/getOffers'];
            isLoading.value = false;
        });
        const openEditForm = (row , index) => {
            console.log(row);
            //get backup of row
            Edited_model.value = row ;
            //close all forms and open only selected row
            offers.value.map(project => project.is_edit_active = false);
            offers.value[index].is_edit_active = true;
            //delete Edited_model.value.photo_link;
        }
        const closeEdit = (row) => {
            ElMessageBox.confirm(
            'You have unsaved changes, save and proceed?',
            'Confirm',
            {
            distinguishCancelAndClose: true,
            confirmButtonText: 'Cancel',
            cancelButtonText: 'Discard Changes',
            }
        )
            .then(() => {
            ElMessage({
                type: 'info',
                message: 'Canceld.',
            })
            })
            .catch(() => {
            Edited_model.value = {};
            offers.value[row].is_edit_active = false;
            ElMessage({
                type: 'info',
                message:'Changes Discribed',
            })
            })
            
        };
        const deleteOffer = (offer) => {
            console.log(offer);
            const data = {
                id: offer.id,
                type:offer.type,
            }
            ElMessageBox.confirm(
            'Are you sure delete the Project. Continue?',
            'Warning',
            {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning',
            }
            )
            .then( async () => {
                isLoading.value = true;
                await store.dispatch('offers/deleteExistingOffer' , data )
                offers.value = store.getters['offers/getOffers'];
                ElMessage({
                type: 'success',
                message: 'Delete successfull',
                })
                isLoading.value = false;
            })
            .catch(() => {
                ElMessage({
                type: 'info',
                message: 'Delete canceled',
                })
            })
        };
        const refreshOffers = async () => {
            isLoading.value = true;
            await fetchOffers();
            offers.value = store.getters['offers/getOffers'];
            isLoading.value = false;
        }
        return{
            deleteOffer,
            refreshOffers,
            Edited_model,
            fetchOffers,
            closeEdit,
            currentPage,
            openEditForm,
            searchValue,
            showDrawer,
            isEditing,
            form,
            store,
            offers,
            isLoading,
            addNewOffer,
            updateExistingOffer,
            deleteExistingOffer
        }
    }
}
</script>

<style lang="scss">
.el-drawer{
    .upload-project-demo{
        width: 100%;
    }
  ::-webkit-scrollbar {
    width: 4px;
    transition: 0.2s ease-in-out;
  }
  /* ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: transparent;
    transition: 0.2s ease-in-out;
  }
  &:hover{
    ::-webkit-scrollbar-thumb {
      transition: 0.2s ease-in-out;
      background: #034750;
    }
  } */
}
.add-project-modal-drawer{
  
  @media (max-width:761px){
    .el-drawer{
      width: 100% !important;
    }
  }
  @media (min-width:762px){
    .el-drawer{
      width: 90% !important;
    }
  }
  @media (min-width:992px){
    .el-drawer{
      width: 50% !important;
    }
  }
  @media (min-width:1200px){
    .el-drawer{
      width: 23% !important;
    }
  }
}
@import '../assets/styles/table.scss';


.upload-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.upload-list .el-upload-list__item {
  cursor: move;
}

</style>